// @tenorlab/nuxt-dashboard-pro
// file: app/middleware/01-selected-menu-item.global.ts
// import { useNavigationStore } from '@/state'
// import { routePathToMenuItemId } from '~/pages-hooks/nuxt-routes'

/*
const DEFAULT_LCID = 'en'

export const getLcidFromRouteParams = (routeParams: RouteParamsGeneric) => {
  if (typeof routeParams !== undefined && typeof routeParams.lcid !== 'undefined') {
    if (Array.isArray(routeParams.lcid) && routeParams.lcid.length > 0) {
      return `${routeParams.lcid[0] || DEFAULT_LCID}`
    } else if (typeof routeParams.lcid === 'string') {
      return routeParams.lcid || DEFAULT_LCID
    }
  }
  return DEFAULT_LCID
}
*/

export default defineNuxtRouteMiddleware(async (to, from) => {
  // const path = to.path
  if (import.meta.client) {
    // let menuItemId = routePathToMenuItemId.get(path) as string
    // if (!menuItemId && path.indexOf('/dashboards/') > -1) {
    //   menuItemId = path.replace('/dashboards', '').replace('/', '')
    //   if (menuItemId.length > 0) {
    //     useNavigationStore().selectMenuItemById(menuItemId)
    //   }
    // }
  } else {
    //await useLocalization().setLocale(getLcidFromRouteParams(to.params))
  }
})
